module.exports = __webpack_public_path__ + "img/guanzhuangwuliao-qian.7fe65191.jpg";